import React from 'react';
import PlannerFrame from './PlannerFrame';

const PortRailScheduling = () => {
  return (
    <PlannerFrame
      title="Port Rail Scheduling"
      src="/port-rail-scheduling.html"
    />
  );
};

export default PortRailScheduling;
